// ../services/event-admin.service.js
import axios from "axios";
import authHeader from "./auth-header";

const API_URL = process.env.REACT_APP_API_URL;

class EventService {
    // ฟังก์ชันสำหรับดึงข้อมูลทั้งหมดของอีเวนต์
    async getallEvent(id) {
        try {
            let response = await axios({
                url: `${API_URL}/master-event-template/getAll`,
                method: "POST",
                headers: authHeader(),
                data: id,
            });
            return response;
        } catch (error) {
            throw error;
        }
    }

    // ฟังก์ชันสำหรับ mapping บริษัท
    async mappingCompany(mapping) { // mapping คือ { id, EventAutoMessageUse, FullLoopUse, AutoDocUse }
        try {
            let response = await axios({
                url: `${API_URL}/master-event-template/mappingCompany`,
                method: "POST",
                data: mapping,
                headers: authHeader(),
            });
            return response;
        } catch (error) {
            throw error;
        }
    }
}

export default new EventService();